export default function initFAQ(el: string) {
    // On faq-item click, toggle the faq-item's class
    const faqEl = document.querySelector(el);

    if (!faqEl) {
        return;
    }

    const faqItems = faqEl.querySelectorAll('.faq-item');

    faqItems.forEach((item) => {
        let title = item.querySelector('.faq-item__title');
        if (!title)
            return;

        title.addEventListener('click', () => {
            item.classList.toggle('is-active');

            // Close other faq-items
            faqItems.forEach((otherItem) => {
                if (otherItem !== item) {
                    otherItem.classList.remove('is-active');
                }
            });
        });
    });
}
